export default class HTTPClient {
  constructor(url, authorization, headers) {
    this.url = url;
    this.authorization = authorization;
    this.headers = headers;
  }

  post = async (path, body, headers = {}) =>
    await fetch(this.url + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authorization ? `Bearer ${this.authorization}` : undefined,
        ...this.headers,
        ...headers,
      },
      body: JSON.stringify(body),
    });

  put = async (path, body, headers = {}) =>
    await fetch(this.url + path, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: this.authorization ? `Bearer ${this.authorization}` : undefined,
        ...this.headers,
        ...headers,
      },
      body: JSON.stringify(body),
    });

  get = async (path, headers = {}) =>
    await fetch(this.url + path, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${this.authorization}`,
        ...this.headers,
        ...headers,
      },
    });

  delete = async (path, body, headers = {}) =>
    await fetch(this.url + path, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${this.authorization}`,
        ...this.headers,
        ...headers,
      },
      body: JSON.stringify(body),
    });
}